// extracted by mini-css-extract-plugin
export var box = "_41-1";
export var checkboxRow = "_41-8";
export var checked = "_41-2";
export var descriptionSpacer = "_41-a";
export var disabled = "_41-3";
export var icon = "_41-6";
export var input = "_41-0";
export var labelSpacer = "_41-9";
export var medium = "_41-5";
export var small = "_41-4";
export var text = "_41-7";